import { render } from "./Pic.vue?vue&type=template&id=6115ff83&ts=true"
import script from "./Pic.vue?vue&type=script&lang=ts"
export * from "./Pic.vue?vue&type=script&lang=ts"

import exportComponent from "/data/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__